import * as actionTypes from "./actionTypes";
import * as types from "./types";

//DB Extractor
const initExtJobschedulesState: types.IExtJobScheduleState = {
  pending: false,
  postJobSchedules: null,
  error: null,
};

export const ExtJobSchedulesReducer = (state = initExtJobschedulesState, action: types.PostExtJobSchedulesActions) => {
  switch (action.type) {
    case actionTypes.POST_EXTJOBSCHEDULES_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_EXTJOBSCHEDULES_SUCCESS:
      return {
        ...state,
        pending: false,
        postJobSchedules: action.payload.dbExtStatus,
        error: null,
      };
    case actionTypes.POST_EXTJOBSCHEDULES_FAILURE:
      return {
        ...state,
        pending: false,
        postJobSchedules: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

//Put job based extractor
const initialPutStateJobSchedules: types.IPutJobSchedulesState = {
  pending: false,
  putJobSchedules: null,
  error: null,
};

export const PutJobSchedulesReducer = (state = initialPutStateJobSchedules, action: types.PutJobSchedulesActions) => {
  switch (action.type) {
    case actionTypes.PUT_EXTJOBSCHEDULES_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.PUT_EXTJOBSCHEDULES_SUCCESS:
      return {
        ...state,
        pending: false,
        putJobSchedules: action.payload.putJobSchedules,
        error: null,
      };
    case actionTypes.PUT_EXTJOBSCHEDULES_FAILURE:
      return {
        ...state,
        pending: false,
        putJobSchedules: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

// DELETE Job Schedules Details

const initDeleteJobSchedulesState: types.IDeleteJobSchedulesState = {
  pending: false,
  success: null,
  error: null,
};

export const DeleteJobSchedulesReducer = (state = initDeleteJobSchedulesState, action: types.DeleteJobSchedulesActions) => {
  switch (action.type) {
      case actionTypes.DELETE_EXTJOBSCHEDULES_REQUEST:
          return {
              ...state,
              success: null,
              pending: true,
          };
      case actionTypes.DELETE_EXTJOBSCHEDULES_SUCCESS:
          return {
              ...state,
              pending: false,
              success: action.success,
              error: null,
          };
      case actionTypes.DELETE_EXTJOBSCHEDULES_FAILURE:
          return {
              ...state,
              pending: false,
              success: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};